import contactFilterTemplate from './contactFilter.html';
import contactFilterModalTemplate from './contactFilterModal.html';

const contactFilterModal = {

    bindings: {
        onFilter: '&',
        onSearch: '&',
        onSelectionFilter: '&'
    },

    template: contactFilterTemplate,

    controller: function ($scope, $state, $ionicLoading, $ionicModal, ApiContacts, ApiInvestors, ApiSelections, ApiUser) {
        this.package = [];
        this.investorType = [];
        this.modal = $ionicModal.fromTemplate(contactFilterModalTemplate, { scope: $scope });
        this.loading = {}; // object used for tracking if all the required data for the component is loaded

        this.$onInit = function () {
            // Filter Data

            // contact type
            ApiUser.getUser().then((res) => {
                this.contactType = res;
                this.loading.user = true;
            });

            // Investor Package (selections)
            ApiSelections.getSelectionsMinimal().then((packages) => {
                this.packageOne = packages || [];
                this.loading.selections = true;
            });

            ApiInvestors.getInvestorsSubtypes().then((investorTypes) => {
                this.investorType = investorTypes;
                this.loading.investorTypes = true;
            });

        };

        /**
         * Inform the parent controller that all the neccessory data for component is loaded
         * @return {void}
         */
        this.emitDataLoaded = () => {
            if (this.loading.selections && this.loading.investorTypes && this.loading.user) {
                // Inform parent controller that the data has been loaded completetly.
            }
        };

        // Show filter modal box
        this.openModal = () => {
            this.modal.show();
        };

        // Close filter modal box
        this.closeModal = () => {
            this.modal.hide();
        };

        this.showChildren = (id, parent) => {
            switch (parent) {
                case 'packageOne':
                    ApiSelections.getSelectionChildren(id).then((packagesTwo) => {
                        this.packageTwo = packagesTwo || [];
                    });
                    break;
                case 'packageTwo':
                    ApiSelections.getSelectionChildren(id).then((packagesThree) => {
                        this.packageThree = packagesThree || [];
                    });
                    break;
                case 'packageThree':
                    ApiSelections.getSelectionChildren(id).then((packagesFour) => {
                        this.packageFour = packagesFour || [];
                    });
                    break;
                default:
                    return false;
            }
        };

        // Handle when user clicks filter-go button
        this.onGoClicked = () => {
            if (this.filterParameter.packageFour) {
                this.filterParameter.package = this.filterParameter.packageFour;
            } else if (this.filterParameter.packageThree) {
                this.filterParameter.package = this.filterParameter.packageThree;
            } else if (this.filterParameter.packageTwo) {
                this.filterParameter.package = this.filterParameter.packageTwo;
            } else if (this.filterParameter.packageOne) {
                this.filterParameter.package = this.filterParameter.packageOne;
            }

            this.searchObject = this.convertToAngularSearchObject(this.filterParameter);
            this.onFilter({ filterParams: this.searchObject });
            this.onSelectionFilter({ selectionFilterParam: this.filterParameter.package });
            this.closeModal();
        };

        // Call the parent handler when user types in the search box of the component
        this.onSearchTextChanging = () => {
            this.onSearch({ searchText: this.searchText });
        };

        // Convert filter parameters to an object suitable for
        // filtering data in the ng-repeat of the contact-list
        this.convertToAngularSearchObject = (filterParameterObj) => {
            try {
                filterParameterObj.package.selectionId
            } catch (error) {
                var filterParameterObj = {
                    package: {
                        selectionId: '',
                        selectionName: ''
                    },
                    investorType: filterParameterObj.investorType,
                    contactType: filterParameterObj.contactType
                };
            }

            let searchObject = {
                contactInfo: {
                    contact: {
                        customer: {
                            id: filterParameterObj.contactType
                        }
                    },
                    investor: {
                        subType: filterParameterObj.investorType
                    }
                }
            };

            // contact type
            if (!filterParameterObj.contactType || filterParameterObj.contactType === '') {
                delete searchObject.contactInfo.contact.customer.id;
                delete searchObject.contactInfo.contact;
            } else {
                // change the contact type object to find team created and package contacts
                if (searchObject.contactInfo.contact.customer.id === 'Package contact') {
                    delete searchObject.contactInfo.contact.customer.id;
                    searchObject.contactInfo.contact.customer = null;
                } else if (searchObject.contactInfo.contact.customer.id === 'Team created') {
                    delete searchObject.contactInfo.contact.customer.id;
                    searchObject.contactInfo.contact.customer;
                }
            }


            // package (selections)
            if (!filterParameterObj.package.selectionId || filterParameterObj.package.selectionId === '') {
                delete filterParameterObj.package;
            }

            // investor type
            if (!filterParameterObj.investorType || filterParameterObj.investorType === '') {
                delete searchObject.contactInfo.investor.subType;
            }

            // remove the json data formatting problem
            if ((!filterParameterObj.investorAccount || filterParameterObj.investorAccount === '') &&
                (!filterParameterObj.investorType || filterParameterObj.investorType === '') &&
                (!filterParameterObj.country || filterParameterObj.country === '')) {
                delete searchObject.contactInfo.investor;
            }

            return searchObject;
        };

        function resolveInvestorType(investorType) {
            var selectedInvestorType = this.investorType.find((type) => {
                return type === investorType;
            });
        }

        /*======================================
        =            Filter removal            =
        ======================================*/

        this.removeContactType = () => {
            if (this.filterParameter.contactType) {
                delete this.filterParameter.contactType;
            }

            if (this.filterParameter.package) {
                delete this.filterParameter.package;
                delete this.filterParameter.packageOne;
                delete this.filterParameter.packageTwo;
                delete this.filterParameter.packageThree;
            }

            this.onGoClicked();
        };

        this.removePackage = () => {
            if (this.filterParameter.package) {
                delete this.filterParameter.package;
                delete this.filterParameter.packageOne;
                delete this.filterParameter.packageTwo;
                delete this.filterParameter.packageThree;
            }

            this.onGoClicked();
        };

        this.removeInvestorType = () => {
            if (this.filterParameter.investorType) {
                delete this.filterParameter.investorType;
            }

            this.onGoClicked();
        };

        /*=====  End of Filter removal  ======*/
    }
};

export default contactFilterModal;



/** WEBPACK FOOTER **
 ** ./src/app/directives/contactFilterModal/contactFilterModal.js
 **/